module.exports = __webpack_public_path__ + "img/media.47884150.svg";